export const VIAGENS_CONTROLE_PERMISSIONS = {
  ACCESS: 'ACCESS_VIAGENS_CONTROLE',
  MANAGEMENT: 'ESTADIA.GESTAO_VISTA',
  STAYS: 'ESTADIA.ESTADIAS',
  INVOICES: 'ESTADIA.FATURAS',
  APPROVE: 'APPROVE_VIAGENS_CONTROLE',
  REJECT: 'REJECT_VIAGENS_CONTROLE',
  BILLING_LIST: 'VIAGENSCONTROLE.BILLINGS.INDEX',
  BILLING_VIAGENS: 'VIAGENSCONTROLE.BILLINGS.VIAGENS',
  BILLING_CREATE: 'VIAGENSCONTROLE.BILLINGS.STORE',
  BILLING_SHOW: 'VIAGENSCONTROLE.BILLINGS.SHOW',
  BILLING_APPROVE: 'VIAGENSCONTROLE.BILLINGS.APPROVE',
  BILLING_REJECT: 'VIAGENSCONTROLE.BILLINGS.REJECT',
  REMOVE_ESTADIA: 'REMOVE_ESTADIA_CONTROLE',
} as const;

type HasAnyPermission = (codes: string[]) => boolean;

export const canValidateViagem = (hasAny: HasAnyPermission) =>
  hasAny([
    VIAGENS_CONTROLE_PERMISSIONS.APPROVE,
    VIAGENS_CONTROLE_PERMISSIONS.REJECT,
  ]);

export const canListBillings = (hasAny: HasAnyPermission) =>
  hasAny([
    VIAGENS_CONTROLE_PERMISSIONS.BILLING_LIST,
    VIAGENS_CONTROLE_PERMISSIONS.BILLING_SHOW,
  ]);

export const canCreateBilling = (hasAny: HasAnyPermission) =>
  hasAny([
    VIAGENS_CONTROLE_PERMISSIONS.BILLING_CREATE,
    VIAGENS_CONTROLE_PERMISSIONS.BILLING_VIAGENS,
  ]);

export const CARRIER_ACCESS_ROLE_KEEP_CURRENT = '__keep_current__';

export const CARRIER_ACCESS_ROLE_OPTIONS = [
  {
    label: 'Usuário de transportadora',
    value: 'carrierMember',
  },
  {
    label: 'Transportadora — validação de estadia (sem faturamento)',
    value: 'carrierMemberStayValidation',
  },
] as const;
